import React from 'react'
import PropTypes from 'prop-types'
import { HStack, Text, useTheme } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function ButtonSelector({
  selected,
  label,
  icon,
  defaultTextColor,
}) {
  const { colors } = useTheme()
  const buttonColor = selected ? '#FFFFFF' : colors.primary.base
  const textColor = selected ? '#FFFFFF' : colors.gray.regular
  return (
    <HStack
      ml={4}
      spacing="16px"
      justifyContent="start"
      alignItems="center"
      h="100%"
      w="100%"
    >
      <FontAwesomeIcon
        color={defaultTextColor || buttonColor}
        size="lg"
        icon={icon}
      />
      <Text color={defaultTextColor || textColor} variant="semibold">
        {label}
      </Text>
    </HStack>
  )
}

ButtonSelector.propTypes = {
  defaultTextColor: PropTypes.string,
  icon: PropTypes.any,
  label: PropTypes.string,
  selected: PropTypes.bool,
}
